// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"SlotFooter_footerContainer__1ZIQP","actionButton":"SlotFooter_actionButton__RWJ6h","buttonText":"SlotFooter_buttonText__1eEH0"};